import { OnboardingAppBar } from "@features/auth";
import { useDevice } from "@hooks/useDevice";
import usePostLoginAccess from "@hooks/usePostLoginAccess";
import { LoaderDialog } from "@memorang/ui";
import { router } from "expo-router";
import { useEffect } from "react";

const PostLoginAccessProvider = () => {
	const { isMobile } = useDevice();
	const { messages, nextPath } = usePostLoginAccess();

	useEffect(() => {
		if (nextPath) {
			router.replace(nextPath as never);
		}
	}, [nextPath]);

	if (!isMobile) {
		return (
			<>
				<OnboardingAppBar showLogo />
				<LoaderDialog messages={messages} visible />
			</>
		);
	}

	return <LoaderDialog messages={messages} visible />;
};

export default PostLoginAccessProvider;
